import { FrontSide, LinearFilter, Mesh, RGBAFormat, Scene, ShaderMaterial, Uniform, Vector2, Vector4, WebGLRenderTarget, } from 'three';
import SphereCameraControls, { CameraEvent } from 'shared/renderingEngine/CameraControls';
import Shaders from 'shared/renderingEngine/shaders/Shaders';
import { SphereTextureGeometry } from 'shared/geometries/SphereTextureGeometry';
import planogramConfig from 'shared/config/PlanogramConfig';
import Cameras2D from './Cameras2D';
import SphereCamera from './SphereCamera';
export default class SphereRenderingEngine {
    constructor() {
        this.sphereScene = new Scene();
        this.rtTexture = new WebGLRenderTarget(window.innerWidth * 2, window.innerHeight * 2, {
            minFilter: LinearFilter,
            magFilter: LinearFilter,
            format: RGBAFormat,
        });
        this.sphereGeometry = new SphereTextureGeometry({
            x: 0,
            y: planogramConfig.HEIGHT / 2,
            width: planogramConfig.WIDTH,
            height: planogramConfig.HEIGHT,
        });
        this.setupSphereScene();
    }
    set canvasSize(canvasSize) {
        this._canvasSize = canvasSize;
        this.cameraControls.sphereCamera.canvasSize = canvasSize;
        this.cameras2D.canvasSize = canvasSize;
        this.cameras2D.updateFromSphereCamera(this.cameraControls.sphereCamera);
    }
    get canvasSize() {
        return this._canvasSize;
    }
    init(scene2D, canvasSize, horizonLine, initialZoom = 1, startingPoint = 0) {
        this.cameras2D = new Cameras2D(initialZoom, startingPoint, canvasSize, this.textureMaterialUniforms);
        const sphereCamera = new SphereCamera(canvasSize, horizonLine, startingPoint);
        this.cameraControls = new SphereCameraControls(sphereCamera);
        this.cameraControlsListener = () => {
            this.cameras2D.updateFromSphereCamera(this.cameraControls.sphereCamera);
        };
        this.cameraControls.addEventListener(CameraEvent.CameraUpdate, this.cameraControlsListener);
        this.scene2D = scene2D;
        this.canvasSize = canvasSize;
    }
    setupSphereScene() {
        this.rtTexture.texture.repeat = new Vector2(0, 0);
        const textureMaterialUniforms = {
            imageTexture: new Uniform(this.rtTexture.texture),
            uvScale: new Uniform(new Vector2(1, 1)),
            uvOffset: new Uniform(new Vector2(0.5, 0.5)),
            backgroundColor: new Uniform(new Vector4(1, 1, 1, 1)),
        };
        const materialScreen = new ShaderMaterial({
            uniforms: textureMaterialUniforms,
            vertexShader: Shaders.renderingTextureVertexShader,
            fragmentShader: Shaders.textureFragmentShader,
            side: FrontSide,
        });
        this.textureMaterialUniforms = textureMaterialUniforms;
        const sphereMesh = new Mesh(this.sphereGeometry.geometry, materialScreen);
        sphereMesh.rotation.y = Math.PI;
        this.sphereScene.add(sphereMesh);
    }
    render(renderer) {
        const camera2D = this.cameras2D.mainCamera;
        if (camera2D === undefined)
            return;
        this.cameraControls.prepareToRender();
        renderer.autoClear = true;
        renderer.setRenderTarget(this.rtTexture);
        renderer.render(this.scene2D, camera2D);
        renderer.autoClear = false;
        renderer.setRenderTarget(null);
        renderer.render(this.sphereScene, this.cameraControls.sphereCamera.camera);
    }
    dispose() {
        this.cameraControls.removeEventListener(CameraEvent.CameraUpdate, this.cameraControlsListener);
    }
}
export const sphereRenderingEngine = new SphereRenderingEngine();
